import { render, staticRenderFns } from "./SelectButtons.vue?vue&type=template&id=a96986b4&scoped=true"
import script from "./SelectButtons.vue?vue&type=script&lang=js"
export * from "./SelectButtons.vue?vue&type=script&lang=js"
import style0 from "./SelectButtons.vue?vue&type=style&index=0&id=a96986b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96986b4",
  null
  
)

export default component.exports